<template>
  <div id="nieuwsbrief" class="nb-section">
    <div class="nb-inner">
      <div class="nb-copy">
        <h2>Schrijf je in voor onze nieuwsbrief</h2>
        <p>Blijf op de hoogte van verhalen, gezinnen en mijlpalen.</p>
      </div>

      <form
        v-if="!success"
        class="nb-form"
        novalidate
        @submit.prevent="inschrijven"
      >
        <input
          v-model.trim="email"
          type="email"
          class="nb-input"
          aria-label="E-mailadres"
          placeholder="Uw e-mailadres"
          name="email"
          autocomplete="email"
          inputmode="email"
          autocapitalize="none"
          autocorrect="off"
          spellcheck="false"
        />
        <button type="submit" class="nb-btn" :disabled="!valid || loading">
          {{ loading ? "..." : "Inschrijven" }}
        </button>
      </form>
      <p v-else class="nb-success">U bent ingeschreven! ✓</p>
      <p v-if="error" class="nb-error" role="alert">
        Inschrijven is niet gelukt. Probeer het later opnieuw.
      </p>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { collection, doc, setDoc } from "firebase/firestore";

export default {
  data() {
    return {
      email: "",
      loading: false,
      success: false,
      error: false,
    };
  },
  computed: {
    valid() {
      return /^\S+@\S+\.\S+$/.test(this.email);
    },
  },
  methods: {
    async inschrijven() {
      if (!this.valid || this.loading) return;
      this.loading = true;
      this.error = false;
      try {
        // Eén enkele write: de doc-id wordt vooraf gegenereerd en als uid
        // meegeschreven, zodat een bezoeker alleen 'create' nodig heeft.
        const ref = doc(collection(db, "nieuwsbrief"));
        await setDoc(ref, {
          uid: ref.id,
          email: this.email,
          date: new Date(),
        });
        this.success = true;
      } catch (e) {
        console.error("Nieuwsbrief inschrijving mislukt: ", e);
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.nb-section {
  background: #fbf4ec;
}
.nb-inner {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 56px 32px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
}
.nb-copy {
  h2 {
    font-family: "Nunito", sans-serif;
    font-weight: 900;
    font-size: 30px;
    letter-spacing: -0.02em;
    color: #241b12;
  }
  p {
    font-size: 16px;
    color: #6b5d52;
    margin-top: 8px;
  }
}
.nb-form {
  display: flex;
  gap: 12px;
  background: #fff;
  padding: 8px;
  border-radius: 16px;
  box-shadow: 0 14px 40px -26px rgba(60, 36, 21, 0.3);
  border: 1px solid rgba(42, 32, 24, 0.06);
}
.nb-form:focus-within {
  outline: 2px solid #ea6b26;
  outline-offset: 2px;
}
.nb-input {
  border: none;
  outline: none;
  background: transparent;
  font-family: "Nunito Sans", sans-serif;
  font-size: 15.5px;
  color: #2a2018;
  padding: 12px 16px;
  width: 260px;
}
.nb-btn {
  border: none;
  cursor: pointer;
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 15px;
  color: #fff;
  background: #ea6b26;
  padding: 12px 26px;
  border-radius: 11px;
  transition: background var(--ws-dur-fast) var(--ws-ease-out),
    transform var(--ws-dur-press) var(--ws-ease-out);
}
@media (hover: hover) and (pointer: fine) {
  .nb-btn:hover:not(:disabled) {
    background: #d65b1b;
  }
}
.nb-btn:active:not(:disabled) {
  transform: scale(0.97);
}
.nb-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.nb-success {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 17px;
  color: #c2541a;
}
.nb-error {
  flex-basis: 100%;
  font-size: 14.5px;
  font-weight: 700;
  color: #b3261e;
}

@media screen and (max-width: 600px) {
  .nb-inner {
    padding: 44px 20px;
  }
  .nb-form {
    width: 100%;
  }
  .nb-input {
    width: 100%;
    flex: 1;
  }
}
</style>
